// dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Wrapper = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: 15px;
  right: 0.5rem;
  bottom: 45px;
  z-index: 2;

  ${MediaQueries.medium} {
    right: 1rem;
  }
`

export const WhatsappImage = styled.img`
  cursor: pointer;
  width: 56px;
  height: 56px;

  ${MediaQueries.notebook} {
    width: 80px;
    height: 80px;
  }
`

export const Dialog = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')} !important;
  background: ${({ theme }) => theme.colors.red};
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  display: block;
  border-radius: 0.4em;
  color: #fff;
  top: -0.2rem;
  right: 4rem;
  min-height: 50px;
  width: 180px;
  padding: 1rem;
  margin: 0;
  transition: all 0.4s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 100px;
    left: 50%;
    width: 0px;
    height: 0px;
    border-width: 18px 18px 0px;
    border-top-style: solid;
    border-right-style: solid;
    border-left-style: solid;
    border-right-color: transparent;
    border-left-color: transparent;
    border-image: initial;
    border-top-color: ${({ theme }) => theme.colors.red};
    border-bottom-style: initial;
    border-bottom-color: initial;
    margin-left: 7px;
    margin-bottom: -16px;
  }
`

export const ChatFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  padding: 20px;
  border-radius: 0 0 12px 12px;

  background-color: #ffffff;

  > span {
    padding: 20px 14px;
    width: 79%;

    border: 1px solid #ced0dd;
    box-sizing: border-box;
    border-radius: 4px;

    margin-right: 8px;
  }
`
